import { Component, OnInit, OnDestroy }     from '@angular/core';
import { Router }                           from '@angular/router';
import { SessionDetails }                   from '../../../../models/program/session-details';
import { BatchResponse }                    from '../../../../models/program/batch-response';
import { ISubscription }                    from 'rxjs/Subscription';
import { ProgramService }                   from '../../../../shared/services/program.service';
import { ActivatedRoute, Params }           from '@angular/router';
import { PermissionsService }               from '../../../../shared/services/permissions.service';
import { UtilsService }                     from '../../../../shared/utils.service';
import { SessionUsersComponent }            from './session-users/session-users.component';
import { NewAndExistingUsers }              from '../../../../models/program/new-and-existing-users';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.less'],
  providers: [UtilsService]
})

export class SessionComponent implements OnInit, OnDestroy {
  session: SessionDetails;
  sessionSub: ISubscription;
  sessionId: number;
  programId: number;
  addUsers: boolean;
  minimalStateObj: {categoryType: string; mapping: string, categoryId: number};
  tabNames: {teams?: string, settings?: string, analytics?: string, users?: string};
  activeTab: number = 0;
  batchResponse: BatchResponse;
  errors: string[]; // TO DO - display errors when
  updated: Date;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private programService: ProgramService,
    private permissionsService: PermissionsService,
    private utils: UtilsService,
  ) { }

  ngOnInit(): void {
    this.tabNames = {
      teams: "Teams",
      settings: "General Settings",
      analytics: "Go to Analytics"
    }
    this.permissionsService.checkPermission('analyticsAccess').subscribe(hasAnalyticsAccess => {
      if (hasAnalyticsAccess) {
        this.tabNames['analytics'] = "Go To Analytics";
      }
    })
    this.route.params.forEach((params: Params) => {
      this.sessionId = +params['sessionId'];
      this.programId = +params['programId'];
      this.minimalStateObj = {
        categoryType: 'session',
        mapping: 'session',
        categoryId: this.sessionId
      };
    });
    this.subscribeToGetSession();
  }

  get sessionStarted() {
    return this.session && this.session.group_set_id;
  }

  addMenuItemSelected(itemName: string): void {
    if (itemName === 'addUsers') {
      this.addUsers = !this.addUsers;
    }
  }

  subscribeToGetSession(): void {
    this.sessionSub = this.programService
      .getSession(this.programId, this.sessionId, true)
      .subscribe(session => {
        if (session) {
          this.session = session;
          if (!this.sessionStarted) {
            this.tabNames['users'] = "Users";
          }
        }
      });
  }

  handleTabClick(title: string): void {
    if (title == this.tabNames.analytics) {
      this.router.navigate(
        ["analytics"],
        {queryParams: {wave: this.sessionId, programId: this.programId}}
      );
    }
  }

  resetData(reset:boolean=true): void {
    if (reset) {
      this.subscribeToGetSession();
      this.activeTab = 2;
      this.updated = new Date();
    }
    this.addUsers = false;
    this.batchResponse = null;
  }

  batchWatch(batchResponse: BatchResponse) {
    this.addUsers = false;
    this.batchResponse = batchResponse;
  }

  ngOnDestroy(): void {
    this.sessionSub.unsubscribe();
  }

  public addManualUsers(users: NewAndExistingUsers) {
    this.programService.addUsersToSession(this.programId, this.sessionId, users).subscribe(resp => {
      this.resetData(true);
    });
  }
}





// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/session/session.component.ts